import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Inicio', href: '/' },
    { name: 'Servicios', href: '/servicios' },
    { name: 'Paquetes', href: '/paquetes-precios' },
    { name: 'Quiénes Somos', href: '/quienes-somos' },
    { name: 'Contacto', href: '/contacto' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      {/* Top Bar */}
      <div className="bg-sinergia-gris-oscuro text-white py-2">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-end space-x-6 text-sm">
            <a href="mailto:contacto@sinergiaempresarialcsce.com" className="flex items-center hover:text-sinergia-verde-claro transition-colors">
              <Mail className="w-4 h-4 mr-2" />
              contacto@sinergiaempresarialcsce.com
            </a>
            <a href="tel:+573175111422" className="flex items-center hover:text-sinergia-verde-claro transition-colors">
              <Phone className="w-4 h-4 mr-2" />
              +57 317 511 1422
            </a>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/logotipo_sinergia.png" 
              alt="Sinergia Empresarial CSCE" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`nav-link text-sinergia-gris-oscuro hover:text-sinergia-verde-claro transition-colors font-medium ${
                  isActive(item.href) ? 'text-sinergia-azul font-semibold' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:block">
            <Link to="/contacto">
              <Button className="btn-primary">
                Agenda tu consulta
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            className="lg:hidden p-2 rounded-md text-sinergia-gris-oscuro hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`text-sinergia-gris-oscuro hover:text-sinergia-azul transition-colors font-medium py-2 ${
                    isActive(item.href) ? 'text-sinergia-azul font-semibold' : ''
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/contacto" onClick={() => setMobileMenuOpen(false)}>
                <Button className="w-full btn-primary mt-4">
                  Agenda tu consulta
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
